import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { DismissedBannerKey } from '@/common/constants';
import { API_URL } from '@/dtos';

const useGetDismissedBannersQuery = () => {
  const { data, isLoading } = useQuery(
    [API_URL.BANNERS_DISMISSED],
    () => api.get<DismissedBannerKey[]>(API_URL.BANNERS_DISMISSED),
  );

  const dismissedBanners = useMemo(() => new Set(data?.data), [data?.data]);

  return {
    dismissedBanners,
    isDismissedBannersLoading: isLoading,
  };
};

export default useGetDismissedBannersQuery;
